import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import s from './index.module.scss';

import PaymentModalV5 from '../../components/common/paymentModalV5';
import { RegularScreen } from './regularScreen';
import { SpecialOfferScreen } from './specialOfferScreen';
import { usePaymentProductSync } from './usePaymentProductSync';
import { isForcedLastDogTrainingPaywall, shouldShowMoneyBack } from './helpers';
import { trackBlockScrollDepth } from '../../utils/scripts/scrollTracker';
import { getParameterFromURL } from '../../utils/scripts';
import { RootState } from '../../store';

function EverydoggyV5() {
  const product = useSelector((state: RootState) => state.data.paymentModal.product);
  const tariff = useSelector((state: RootState) => state.data.tariff);
  const isDiscount = useSelector((state: RootState) => state.data.isDiscount);
  const dogTranslator = useSelector((state: RootState) => state.data.dogTranslator) === 'true';
  const vetOnboarding = useSelector((state: RootState) => state.data.vetOnboarding);
  const nutritionOnboarding = useSelector((state: RootState) => state.data.nutritionOnboarding);
  const puppyBlues = useSelector((state: RootState) => state.data.puppyBlues);
  const lastDogTraining = useSelector((state: RootState) => state.data.lastDogTraining);

  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  const puppyOnboarding = getParameterFromURL('puppyOnboarding') === 'true';
  const customV52 = getParameterFromURL('config') === 'customV52';

  const showVetOnboarding = !dogTranslator && vetOnboarding;
  const isLastDogTrainingPaywall = lastDogTraining || isForcedLastDogTrainingPaywall();
  const showMoneyBack = shouldShowMoneyBack({ tariff, lastDogTraining });

  usePaymentProductSync(tariff, product.name);

  // Mount-only side effects: scroll tracking, body overflow.
  useEffect(() => {
    trackBlockScrollDepth(s.firstScreenWrapper, 'paywall');
    document.querySelector('body').style.overflowX = 'visible';
    (document.querySelector('.app') as HTMLElement).style.overflow = 'visible';
  }, []);

  // Track scroll depth for the special-offer screen whenever we land on a discount tariff.
  useEffect(() => {
    if (isDiscount) {
      trackBlockScrollDepth(s.firstScreenWrapperV2, 'special_offer');
    }
  }, [isDiscount]);

  return (
    <>
      {isDiscount ? (
        <SpecialOfferScreen
          tariff={tariff}
          product={product}
          darkTheme={darkTheme}
          showMoneyBack={showMoneyBack}
        />
      ) : (
        <RegularScreen
          tariff={tariff}
          productName={product.name}
          dogTranslator={dogTranslator}
          showVetOnboarding={showVetOnboarding}
          nutritionOnboarding={nutritionOnboarding}
          puppyOnboarding={puppyOnboarding}
          puppyBlues={puppyBlues}
          customV52={customV52}
          isLastDogTrainingPaywall={isLastDogTrainingPaywall}
          showMoneyBack={showMoneyBack}
        />
      )}
      <PaymentModalV5 label={null} />
    </>
  );
}

export default EverydoggyV5;
